import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import {
  CountryItem,
  TravelCategory,
  TravelItemMinimal,
  UserItem,
  UserItemMinimal,
} from '../../../api/models';
import {
  CountryService,
  IdentityService,
  TravelService,
} from '../../../api/services';
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  of,
  switchMap,
} from 'rxjs';
import { IdentityControllerGetAll$Params } from '../../../api/fn/identity/identity-controller-get-all';
import { enumUserRole } from '../../../shared/utils/enum-user-role';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { CountryControllerGetAll$Params } from '../../../api/fn/country/country-controller-get-all';
import { correctDate } from '../../../shared/utils/utils';
import { Router } from '@angular/router';
import { IdentityControllerGetAllTourLeaders$Params } from '../../../api/fn/identity/identity-controller-get-all-tour-leaders';

@Component({
  selector: 'app-departures',
  templateUrl: './departures.component.html',
  styleUrl: './departures.component.scss',
})
export class DeparturesComponent {
  travels: TravelItemMinimal[] = [];
  limit = 10;
  skip = 0;
  totalRecords = 0;
  types: TravelCategory[] = [];
  autocompleteLeaders$ = new BehaviorSubject<string>('');
  suggestedLeaders: UserItem[] = [];
  autocompleteCountries$ = new BehaviorSubject<string>('');
  suggestedCountries: CountryItem[] = [];
  loading = false;
  loadingMore = false;

  frmSearch: FormGroup = new FormGroup({
    destinations: new FormControl(undefined),
    categories: new FormControl<number[] | undefined>(undefined),
    leader: new FormControl(undefined),
  });

  constructor(
    private title: Title,
    private travelService: TravelService,
    private identityService: IdentityService,
    private countryService: CountryService,
    private router: Router
  ) {}

  ngOnInit() {
    this.title.setTitle('SocialTravels - Partenze');
    this.getTravels(true);
    this.getTravelTypes();

    this.autocompleteLeaders$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((query) => {
          if (query) {
            let params: IdentityControllerGetAllTourLeaders$Params = {
              limit: 1000,
              skip: 0,
              query,
            };
            return this.identityService.identityControllerGetAllTourLeaders(
              params
            );
          } else {
            return of({
              data: { list: [] },
            });
          }
        })
      )
      .subscribe({
        next: (res) => {
          this.suggestedLeaders = res.data.list;
        },
      });

    this.autocompleteCountries$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((query) => {
          if (query) {
            let params: CountryControllerGetAll$Params = {
              query,
            };
            return this.countryService.countryControllerGetAll(params);
          } else {
            return of({
              data: { list: [] },
            });
          }
        })
      )
      .subscribe({
        next: (res) => {
          this.suggestedCountries = res.data.list;
        },
      });
  }

  filterLeaders(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteLeaders$.next(query);
  }

  filterCountries(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteCountries$.next(query);
  }

  submitSearch() {
    const country_obj = this.frmSearch.get('destinations')?.value;
    const categories = this.frmSearch.get('categories')?.value;
    const leader = this.frmSearch.get('leader')?.value;

    if (categories || leader || country_obj) {
      this.router.navigate(['/viaggi-di-gruppo/departures'], {
        queryParams: {
          type: categories,
          country: country_obj?.ISO,
          leader: leader?.id,
        },
      });
    } else {
      this.router.navigate(['/viaggi-di-gruppo/departures'], {
        queryParams: {},
      });
    }
    this.getTravels(true);
  }

  getTravelTypes() {
    this.travelService.travelControllerGetCategories().subscribe({
      next: (res) => {
        this.types = res.data.list;
      },
    });
  }

  getTravels(isInitial = false) {
    if (isInitial) {
      this.loading = true;
    } else {
      this.loadingMore = true;
    }
    const country_obj = this.frmSearch.get('destinations')?.value
      ? this.frmSearch.get('destinations')?.value
      : undefined;
    const leader = this.frmSearch.get('leader')?.value;
    this.travelService
      .travelControllerGetEarliest({
        limit: this.limit,
        skip: this.skip,
        categories: this.frmSearch.get('categories')?.value,
        countries: country_obj?.ISO,
        tour_leaders: leader?.id,
      })
      .subscribe({
        next: (res) => {
          this.travels = [...this.travels, ...res.data.list];
          //this.travels = res.data.list;
          this.totalRecords = res.data.count;
          this.loading = false;
          this.loadingMore = false;
        },
      });
  }

  showMore() {
    this.loadingMore = true;
    this.skip += this.limit;
    this.getTravels();
  }

  getLeadersNameToDisplay(u: UserItemMinimal) {
    return u.name + ' ' + u.last_name;
  }
}
